import React, {
  useReducer, ReactNode,
} from 'react';
import {
  StateContext, initialState,
  DispatchContext,
} from '../../../store';
import rootMapReducer from '../../../store/modules/root/root-map.reducer';

interface IStoreProviderProps {
  children: ReactNode;
}

const StoreProvider = ({ children }: IStoreProviderProps): JSX.Element => {
  const [state, dispatch] = useReducer(rootMapReducer, initialState);
  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};

StoreProvider.displayName = 'StoreProvider';

export default StoreProvider;
